export const ROUTER_PATHS = {
  LOGIN: '/login',
  ROOT: '/',
  RESOURCES: '/resources',
  NOT_FOUND: '/404',
  PROJECTS: '/projects',
  SETTINGS: '/settings'
};
